import { Injectable } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { Utils } from '../../utils/utils';
import { CheckedDataService } from '../models/abstractions';
import { ConstraintTypeEnum } from '../models/enum';
import { IConstraint } from '../models/model.constraint';
import { ConstraintSources } from '../view-models/view-model.constraint';
import { CheckedDataServiceList } from '../view-models/view-model.dataservice';

@Injectable({
    providedIn: 'root',
})
export class SeConstraintConfiguratorService {
    private _constraintSources: ConstraintSources = new ConstraintSources();
    private _allConstraints: (IConstraint | null)[] = [];
    private _checkedDataServices: CheckedDataServiceList | null = null;
    private isApproveSub: Subscription | null = null;
    isApproved: boolean = false;

    public initializeConstraints(constraints: (IConstraint | null)[], isApproved$: Observable<boolean>) {
        this.isApproveSub?.unsubscribe();
        this.isApproveSub = isApproved$.subscribe((isApproved) => (this.isApproved = isApproved));

        this._constraintSources = new ConstraintSources();

        const constraintsWithSources = constraints.filter((c) => this.isConstraintAdmittingSources(c));
        for (let constraint of constraintsWithSources) {
            this._constraintSources.addConstraintSources(constraint);
        }

        this._allConstraints = constraints;
    }

    public initializeCheckedDataServices(checkedDataServices: CheckedDataService[]) {
        this._checkedDataServices = new CheckedDataServiceList(checkedDataServices);
    }

    public isSource(propertyId: string): boolean {
        if (!this._constraintSources.getSource(propertyId)) return false;
        else return true;
    }

    public isListSource(listName: string): boolean {
        const sources = this._constraintSources.getSourcesByListName(listName);
        if (!sources || sources.length === 0) return false;
        else return true;
    }

    public get constraintSources(): ConstraintSources {
        return this._constraintSources;
    }

    public get allConstraints(): IConstraint[] {
        return this._allConstraints.filter(Utils.isNotEmpty);
    }

    public get validationConstraints(): IConstraint[] {
        return this._allConstraints
            .filter((c) => c?.constraintType == ConstraintTypeEnum.Validation)
            .filter(Utils.isNotEmpty);
    }

    public get checkedDataServices(): CheckedDataServiceList | null {
        return this._checkedDataServices;
    }

    public get normalValuesConstraints(): IConstraint[] {
        return this._allConstraints
            .filter((c) => c?.constraintType === ConstraintTypeEnum.NormalValue)
            .filter(Utils.isNotEmpty);
    }

    private isConstraintAdmittingSources(constraint: IConstraint | null): boolean {
        if (!constraint) return false;

        switch (constraint.constraintType) {
            case ConstraintTypeEnum.NormalValue:
            case ConstraintTypeEnum.CustomValue:
                return false;
            default:
                return true;
        }
    }
}
